import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import Modal from "./Modal"
import { Home } from "../../../home"


const ProjectDetail = () => {
	const { id } = useParams()
	const [showModal, setShowModal] = useState(false)

	useEffect(() => {
		if (id) {
			setShowModal(true)
		}
	}, [id])

	const closeModal = () => {
		setShowModal(false)
	}

	return (
		<>
			{showModal && <Modal show={showModal} closeModal={closeModal} expediente={id} />}
			{
				<Home />
			}
		</>
	)
}

export default ProjectDetail
